import css from 'styled-jsx/css';

const staticStyles = css`
  @import 'src/common/styling/_mixins-scss/screen-size';
  @import 'src/common/styling/_mixins-scss/rem';

  .InvestmentDepositForm__content {
    max-width: 360px;
  }

  .InvestmentDepositForm {
    &__btns {
      display: flex;
      justify-content: space-between;

      :global(.DefaultButton) {
        width: 48%;
      }
    }

    &__desc {
      color: #777777;
      font-size: rem(12px);
      margin-top: -10px;
      margin-bottom: 25px;

      :global(.MoneyCell__inner) {
        display: inline-block;
        height: auto;
        margin-left: 5px;
        font-weight: 500;

        :global(span) {
          color: #777777 !important;
          font-size: rem(12px) !important;
        }
      }
    }
  }
`;

export default staticStyles;
